"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpoints = exports.useStyles = exports.useVariables = exports.useTheme = void 0;

var react_1 = require("@emotion/react");

function useTheme() {
  return (0, react_1.useTheme)();
}

exports.useTheme = useTheme;

function useVariables() {
  var variables = useTheme().variables;
  return variables;
}

exports.useVariables = useVariables;

function useStyles() {
  var styles = useTheme().styles;
  return styles;
}

exports.useStyles = useStyles;

function useBreakpoints() {
  var breakpoints = useTheme().breakpoints;
  return breakpoints;
}

exports.useBreakpoints = useBreakpoints;